module.exports = __webpack_public_path__ + "static/img/849_phase_function_Paper_Points.ddb60f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/849_phase_function_Paper_Points.png
// module id = 5uLT
// module chunks = 0